/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import Auto from "components/AutoComplete/AutoComplete";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MuiPhoneNumber from "material-ui-phone-number";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { addCustomerData, getCustomerByID, updateCustomerData } from "utils/api";
import { blank, generateDataList, getScreenRight, handleStreetAddress, showResMsg, validateEmailField, validateField, validatePhoneNumberField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";


const errMsg = {
  color: `red`,
  fontSize: `11px`,
};
let fetchedcustomer;
let routePath = "";

function AddNewCustomer() {
  const { id } = useParams();
  const stateListRef = useRef([]);
  const countryListRef = useRef([]);
  const [screenName, setScreenName] = useState("Add New Customer");
  const [userTypeErr, setUserTypeErr] = useState(false);
  const [bussinessNameErr, setBussinessNameErr] = useState(false);
  const [bussinessIDErr, setBussinessIDErr] = useState(false);
  const [customerCodeErr, setcustomerCodeErr] = useState(false);
  const [firstNameErr, setFirstNameErr] = useState(false);
  const [lastNameErr, setLastNameErrErr] = useState(false);
  const [emailAddressErr, setEmailAddressErr] = useState(false);
  const [mobileNumberErr, setMobileNumberErr] = useState(false);
  const [emailTitleErr, setemailTitleErr] = useState('');
  const [pNumberErrMsg, setpNumberErrMsg] = useState('');
  const [streetAddressErr, setStreetAddressErr] = useState(false);
  const [cityErr, setCityErr] = useState(false);
  const [zipCodeErr, setZipCodeErr] = useState(false);
  const [paymentTypeErr, setPaymentTypeErr] = useState(false);
  const [accountNumberErr, setAccountNumberErr] = useState(false);
  const [state, setState] = useState([]);
  const [country, setCountry] = useState([])
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const [uiVisiblity, SetUivisibility] = useState(false)
  const [disableColor, setDisableColor] = useState(false);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  let countryData = useSelector((state) => state.countryState.countryStateMenu.country)
  let stateData = useSelector((state) => state.countryState.countryStateMenu.state)
  const [values, setValues] = React.useState({
    customerType: "Business",
    countryCode: "",
    businessName: "",
    businessID: "",
    customerCode: "",
    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "+61",
    streetAddress: "",
    city: "",
    zipCode: "",
    stateId: "",
    countryId: "",
    addressType: "Home",
    customerLocationLatitude: "",
    customerLocationLongitude: "",
    paymentType: "Self-Payment",
    accountNumber: "",
    customerStatus: "Active",
    notes: "",
    businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.businessUserID
  });

  const handleChange = (name) => (event) => {
    if (event.target.validity !== undefined && event.target.validity.valid === true) {
      setValues({ ...values, [name]: event.target.value });
    }
    else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };
  useEffect(() => {
    if (values.paymentType === "Self-Payment") {
      setValues({ ...values, accountNumber: '' })
      values.accountNumber = "";
    }
    if (values.customerType === "Individual") {
      setValues({ ...values, businessID: '', businessName: '', customerCode: '' });
    }
  }, [values.paymentType, values.customerType])

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get('add');
    routePath = paramValue ? '/addOrder/new' : '/customers';
    (async () => {
      getRight()
      stateListRef.current = stateData;
      countryListRef.current = countryData;
      setCountry(await generateDataList(countryData, "_id", "countryName"));
      setState(await generateDataList(stateData, "_id", "stateName"));
      if (id !== undefined) {
        values._id = id
        getCustomerByID(values, (data) => {
          if (data.Result_Output.length > 0) {
            fetchedcustomer = data.Result_Output[0];
            setValues(fetchedcustomer)
          }
          if (fetchedcustomer.paymentType === "")
            SetUivisibility(false)
          else if (fetchedcustomer.paymentType === "Account Payment")
            SetUivisibility(true);
        }, dispatch)
      }
    }
    )();
  }, [dispatch])
  async function getRight() {
    let right = await getScreenRight("Customers")
    if (right === "Full Access") setDisableColor(false)
    else setDisableColor(true)
  }

  const clearErrorStates = () => {
    setBussinessIDErr(false);
    setBussinessIDErr(false);
    setBussinessNameErr(false);
    setBussinessNameErr(false);
    setFirstNameErr(false);
    setLastNameErrErr(false);
    setEmailAddressErr(false);
    setMobileNumberErr(false);
    setStreetAddressErr(false);
    setAccountNumberErr(false);
    setAccountNumberErr(false);
  };

  const addCustomer = async () => {
    clearErrorStates();
    let mandateFlag = false;
    mandateFlag = validateField(values.customerType, setUserTypeErr) || mandateFlag;
    if (values.customerType === 'Business') {
      mandateFlag = validateField(values.businessName, setBussinessNameErr) || mandateFlag;
      mandateFlag = validateField(values.businessID, setBussinessIDErr) || mandateFlag;
    }
    mandateFlag = validateField(values.firstName, setFirstNameErr) || mandateFlag;
    mandateFlag = validateField(values.lastName, setLastNameErrErr) || mandateFlag;
    mandateFlag = validateEmailField(values.emailAddress, setEmailAddressErr, setemailTitleErr) || mandateFlag;
    mandateFlag = validatePhoneNumberField(values.phoneNumber, setMobileNumberErr, setpNumberErrMsg) || mandateFlag;
    mandateFlag = validateField(values.streetAddress, setStreetAddressErr) || mandateFlag;
    if (values.paymentType === 'Account Payment') {
      mandateFlag = validateField(values.accountNumber, setAccountNumberErr,) || mandateFlag;
    }
    if (mandateFlag) {
      return;
    }
    const apiFunction = id === undefined ? addCustomerData : updateCustomerData;
    apiFunction(values, (data) => {
      if (data.Result_Status) {
        showResMsg(id === undefined ? genericMessage.added : genericMessage.updated, 1000, data.Result_Status, navigate, routePath);
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);
  };

  const handleStreetOnChange = (e) => {
    if (e.target.value === "") {
      setValues((prevValues) => ({
        ...prevValues,
        streetAddress: "",
        city: "",
        countryId: "",
        zipCode: "",
        stateId: "",
      }));
    } else {
      setValues((prevValues) => ({
        ...prevValues,
        streetAddress: e.target.value,
      }));
    }
  }
  const setPhoneValues = (phone, country) => {
    values.onlyPhoneNumber = phone.slice(country.dialCode.length);
    console.log("phone", phone.slice(country.dialCode.length));
    values.phoneNumber = phone.slice(country.dialCode.length);
    values.phoneNumber = phone
    values.countryCode = "+" + country.dialCode;
  };
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  const handleKeyDown = (e) => {
    const inputElement = document.querySelector('.GoogleInput');
    if (e.key === "Enter" && inputElement && inputElement.contains(e.target)) {
      e.preventDefault();
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar screenName=" Edit Standard Plan Feature" />
      <MDBox mt={6} mb={3}>
        <form >
          <Grid container spacing={2}>
            <Grid item xs={12} spacing={6}>
              <Card sx={{ boxShadow: "none" }}>
                <MDBox
                  mx={2}
                  mt={-3}
                  mb={1.5}
                  py={2}
                  px={2}
                  variant="gradient"
                  bgColor={sidenavColor}
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    {screenName}
                  </MDTypography>
                </MDBox>
                <MDBox pt={4} pb={3} px={3}>
                  <Grid container columnSpacing={5}>
                    <Grid item xs={12} lg={3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Customer Type</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "44.11px" }}
                            label="Customer Type"
                            autoFocus={true}
                            onChange={handleChange("customerType")}
                            value={values.customerType}
                          >
                            {/* <MenuItem value="">Select..</MenuItem> */}
                            <MenuItem value="Business">Business</MenuItem>
                            <MenuItem value="Individual">Individual</MenuItem>

                          </Select>

                        </FormControl>
                        {userTypeErr ? <span style={errMsg}>Customer Type can't be blank</span> : ""}
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Business Name"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 30
                            }}
                            disabled={values.customerType === "Individual" ? true : false}
                            value={values.businessName}
                            onChange={handleChange("businessName")}
                          />
                          {bussinessNameErr ? <span style={errMsg}>Business Name can't be blank</span> : ""}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="ABN(Australia Business Number)"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[0-9]+$",
                              maxLength: 30
                            }}
                            disabled={values.customerType === "Individual" ? true : false}
                            value={values.businessID}
                            onChange={handleChange("businessID")}
                          />
                          {bussinessIDErr ? <span style={errMsg}>ABN can't be blank</span> : ""}
                        </MDBox>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Customer Code"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 5
                            }}
                            disabled={values.customerType === "Individual" ? true : false}
                            value={values.customerCode}
                            onChange={handleChange("customerCode")}
                          />
                          {customerCodeErr ? <span style={errMsg}>customer Code can't be blank</span> : ""}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="First Name"
                            variant="outlined"
                            fullWidth
                            autoComplete="off"
                            inputProps={{
                              pattern: "^[a-zA-Z ]+$",
                              maxLength: 30
                            }}
                            value={values.firstName}
                            onChange={handleChange("firstName")}
                          />
                          {firstNameErr ? <span style={errMsg}>First Name can't be blank</span> : ""}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Last Name"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z ]+$",
                              maxLength: 30
                            }}
                            value={values.lastName}
                            onChange={handleChange("lastName")}
                          />
                          {lastNameErr ? <span style={errMsg}>Last Name can't be blank</span> : ""}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Email Address"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              // pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 50
                            }}
                            value={values.emailAddress}
                            onChange={handleChange("emailAddress")}
                          />
                          {emailAddressErr ? <span style={errMsg}>{emailTitleErr}</span> : ""}
                        </MDBox>

                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MuiPhoneNumber
                        defaultCountry={"au"}
                        type="text"
                        label="Mobile Number"
                        variant="outlined"
                        fullWidth
                        value={values.phoneNumber}
                        onChange={(phone, country) => setPhoneValues(phone, country)}
                      />
                      {mobileNumberErr ? <span style={errMsg}>{pNumberErrMsg}</span> : ""}
                    </Grid>
                    <Grid item xs={12} lg={9}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <Auto
                            onChange={handleStreetOnChange}
                            onPlaceSelected={(place, e) => handleStreetAddress(place, e, (data) => {
                              setValues((prevValues) => ({
                                ...prevValues,
                                zipCode: data.zipCode,
                                city: data.city,
                                countryId: data.countryId,
                                stateId: data.stateId,
                                streetAddress: data.streetAddress,
                                customerLocationLatitude: data.locationLatitude,
                                customerLocationLongitude: data.locationLongitude
                              }));
                            }, stateListRef, countryListRef)}
                            value={values.streetAddress} />
                          {streetAddressErr ? <span style={errMsg}>Street Address can't be blank</span> : ""}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Address Type</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "44.11px" }}
                            label="Customer Type"
                            onChange={handleChange("addressType")}
                            value={values.addressType}
                          >
                            {/* <MenuItem value="">Select..</MenuItem> */}
                            <MenuItem value="Home">Home</MenuItem>
                            <MenuItem value="Office">Office</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>

                          </Select>

                        </FormControl>
                        {userTypeErr ? <span style={errMsg}>Customer Type can't be blank</span> : ""}
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="City"
                            variant="outlined"
                            fullWidth
                            disabled
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 30
                            }}
                            value={values.city}
                            onChange={(e) => setValues({ ...values, city: e.target.value })}
                          />
                          {cityErr ? <span style={errMsg}>City can't be blank</span> : ""}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Zip Code"
                            variant="outlined"
                            fullWidth
                            disabled
                            inputProps={{
                              pattern: "^[0-9]+$",
                              maxLength: 4
                            }}
                            value={values.zipCode}
                            onChange={(e) => setValues({ ...values, zipCode: e.target.value })}
                          />
                          {zipCodeErr !== "" ? <span style={errMsg}>{zipCodeErr}</span> : ""}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Country</InputLabel>

                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "44.11px" }}
                            label="Country"
                            disabled
                            // onChange={handleChange("countryId")}
                            value={values.countryId}
                            onChange={(e) => setValues({ ...values, countryId: e.target.value })}
                          >
                            {country}
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">State</InputLabel>

                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "44.11px" }}
                            label="State"
                            disabled
                            // onChange={handleChange("stateId")}
                            value={values.stateId}
                            onChange={(e) => setValues({ ...values, stateId: e.target.value })}
                          >
                            {state}
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Payment Type</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "44.11px" }}
                            label="Payment Type"
                            onChange={handleChange("paymentType")}
                            value={values.paymentType}
                          >
                            <MenuItem value="Self-Payment">Self Payment</MenuItem>
                            <MenuItem value="Account Payment">Account Payment</MenuItem>
                          </Select>

                        </FormControl>
                        {paymentTypeErr ? <span style={errMsg}>Payment Type can't be blank</span> : ""}
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Account Number"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[0-9]+$",
                              maxLength: 30
                            }}
                            disabled={values.paymentType === "Self-Payment" ? true : false}
                            value={values.accountNumber}
                            onChange={handleChange("accountNumber")}
                          />
                          {accountNumberErr ? <span style={errMsg}>Account Number can't be blank</span> : ""}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Notes"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 500
                            }}
                            value={values.notes}
                            onChange={handleChange("notes")}

                          />
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Customer Status</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "44.11px" }}
                            label="Customer Status"
                            onChange={handleChange("customerStatus")}
                            value={values.customerStatus}
                          >
                            <MenuItem value="Active">Active</MenuItem>
                            <MenuItem value="Inactive">Inactive</MenuItem>
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
          <Grid
            container
            mt={2}
            columnSpacing={4}
            alignItems="center"
            display="flex"
            justifyContent="center"
          >
            <Grid item xs={12} md={4} spacing={2} lg={1.2}>
              <Link to={routePath}>
                <MDButton
                  className="btn-block center-container-btn btn-warning btn-back rightSpace"
                  color="warning"
                  fullWidth
                >
                  Cancel
                </MDButton>
              </Link>
            </Grid>
            <Grid item xs={12} md={4} spacing={2} lg={1.2}>
              <MDButton
                rel="noreferrer"
                variant="gradient"
                className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                color={disableColor ? "secondary" : "success"}
                fullWidth
                onClick={disableColor ? blank : addCustomer}
              >
                Save
              </MDButton>
            </Grid>
          </Grid>
        </form>
      </MDBox>
    </DashboardLayout >
  );
}

export default AddNewCustomer;
